import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
